import React from 'react';
import { PlayerControls, PlayerControlsContext } from '../_contexts/player-eventhandling-context';

export const usePlayerEventHandling = (): PlayerControls => {
  const values = React.useContext(PlayerControlsContext);

  return { ...values };
};

export default usePlayerEventHandling;
